import s from "styled-components";

const gutter = 1;
export const Wrap = s.div`
  overflow: hidden;
`;
export const Item = s.div`
  cursor: pointer;
  float: left;
  width: calc(33.333% - ${gutter * 2}px);
  padding-bottom: calc(33.333% - ${gutter * 2}px);
  position: relative;
  height: 0;
  overflow: hidden;
  margin: ${gutter}px;
  //border-radius: 7px;
  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
